export default "__VITE_ASSET__3f99bd08__"